export const isMessagePort = (sender) => {
    return (typeof sender.start === 'function');
};
//# sourceMappingURL=/build/es2018/guards/message-port.js.map